import React from 'react'

class CalendarDays extends React.Component {

  renderDayName (day, index) {
    return (
      <div className='calendar-day-name' key={index}>
        <div className='pull-right'>{day}</div>
      </div>
    )
  }

  render () {
    return (
      <div>
        {this.props.days.map((day, index) => this.renderDayName(day.day, index))}
      </div>
    )
  }
}

export default CalendarDays;